export const PlanManager_START = 'PlanManager_START';
export const PlanManager_END = 'PlanManager_END';
export const PlanManager_ERROR = 'PlanManager_ERROR';
export const PlanManager_SUCCESS = 'PlanManager_SUCCESS';
export const PlanManager_FAIL = 'PlanManager_FAIL';
export const IsDataSubmitedSuccessfully = 'IsDataSubmitedSuccessfully';

export const PlanManager_DD_SUCCESS = 'PlanManager_DD_SUCCESS';

export const PlanManager_UPDATE_START = 'PlanManager_UPDATE_START';
export const PlanManager_UPDATE_SUCCESS = 'PlanManager_UPDATE_SUCCESS';
export const PlanManager_UPDATE_FAIL = 'PlanManager_UPDATE_FAIL';

export const PlanManager_ACTION_START = 'PlanManager_ACTION_START';
export const PlanManager_ACTION_SUCCESS = 'PlanManager_ACTION_SUCCESS';
export const PlanManager_ACTION_FAIL = 'PlanManager_ACTION_FAIL';
